import { useTranslate } from "@tolgee/react";
import { Link } from "react-router-dom";
import { type NewRequestPageBreadcrumbProps } from "./NewRequestPageBreadcrumb.types";

export const NewRequestPageBreadcrumb = ({
  orderId,
  orderItemId,
}: NewRequestPageBreadcrumbProps) => {
  const { t } = useTranslate();

  return (
    <Link to={`/orders/${orderId}/order-items/${orderItemId}/new-request`}>
      {t("navigation.newRequest")}
    </Link>
  );
};
